import { ofType } from 'redux-observable';
import {
    filter, map, switchMap, take,
} from 'rxjs';

import { STEP_STATUS } from 'src/assets/qamodules/default';
import { setGameEvent, setInspectorEvent } from 'src/slices/gameEvents.slice';
import { setStepsDisabledStatus, syncModules, updateStepStatus } from 'src/slices/qamodules.slice';
import { INSPECTOR_EVENTS, SDK_EVENTS } from 'src/vars';

function createEpic({ action$, state$, event, stepKey, stepDisabled = false }) {
    return action$.pipe(
        ofType(setGameEvent.type),
        filter((action) => action.payload.event === event),
        map(() => setStepsDisabledStatus({ stepsDisabledStatus: {
            ...state$.value.qaModules.stepsDisabledStatus,
            [stepKey]: stepDisabled,
        } })),
    );
}

const qaModulesEpics = {
    initGameLoadingFinishedEpic: (action$, state$) => (
        createEpic({
            action$,
            state$,
            event: SDK_EVENTS.GAME_LOADING_FINISHED,
            stepKey: 'sdk-basics-game-loading-finished',
            stepDisabled: false,
        })
    ),
    initCommercialBreaksEpic: (action$, state$) => (
        createEpic({
            action$,
            state$,
            event: SDK_EVENTS.COMMERCIAL_BREAKS,
            stepKey: 'ad-implementation-commercial-breaks',
            stepDisabled: false,
        })
    ),
    initRewardedBreaksEpic: (action$, state$) => (
        createEpic({
            action$,
            state$,
            event: SDK_EVENTS.REWARDED_BREAKS,
            stepKey: 'ad-implementation-rewarded-breaks',
            stepDisabled: false,
        })
    ),
    initPointerLockDuringAdEpic: (action$, state$) => action$.pipe(
        ofType(setInspectorEvent.type),
        filter((action) => action.payload.event === INSPECTOR_EVENTS.POINTER_LOCK_DURING_AD),
        filter(() => {
            const module = state$.value.qaModules.modules.find(({ moduleID }) => moduleID === 'ad-implementation');
            const step = module?.steps.find(({ stepKey }) => stepKey === 'ad-implementation-pointer-lock');

            return step?.stepStatus !== STEP_STATUS.FAILED;
        }),
        take(1),
        switchMap(() => [
            updateStepStatus({
                moduleID: 'ad-implementation',
                stepKey: 'ad-implementation-pointer-lock',
                stepStatus: STEP_STATUS.FAILED,
            }),
            syncModules({ gameID: state$.value.game.gameID }),
        ]),
    ),
};

export default qaModulesEpics;
